import styled from 'styled-components'

import { pxToRem, getCardBgColor } from 'styles/functions'

interface StyledLayoutProps {
  $isMobile?: boolean;
  $widescreen?: boolean;
  theme: any;
}
export const StyledLayout = styled.div<StyledLayoutProps>`
  position: relative;
  min-height: 100vh;
  height: 100%;
  ${({ $isMobile, $widescreen }) => !$isMobile && !$widescreen && `min-width: ${pxToRem(500)}`};
  max-width: ${({ theme, $widescreen }) =>
    $widescreen ? '100%' : (theme.card_fullscreen ? '70%' : pxToRem(theme.card_max_width || 500))};
  margin: auto;
  display: flex;
  flex-direction: column;
  flex: auto;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.card_background_color || 'white'};
`

interface StyledCardProps {
  $height: number;
  theme: any;
  $themeCustom: any;
}
// 161px is the footer height
export const StyledCard = styled.div<StyledCardProps>`
  width: 100%;
  min-height: ${({ theme, $height }) => `calc(100vh - ${theme.custom_min_height || $height}px`});
  padding-bottom: ${pxToRem(20)};
  ${({ theme }) =>
          theme.card_background_image_url &&
          `background: url(/static/background/${theme.card_background_image_url})`};
  ${({ theme }) => theme.card_background_image_url && 'background-attachment: fixed'};
  background-size: ${({ theme }) => (theme.card_background_image_repeat ? 'contain' : 'cover')};
  background-color: ${({ theme, $themeCustom }) => getCardBgColor(theme, $themeCustom)};
`

interface StyledImageContainerProps {
  $theme: any;
}
export const StyledImageContainer = styled.div<StyledImageContainerProps>`
  margin: 0 ${pxToRem(20)};
  padding-top: ${pxToRem(20)};
  background-color: ${({ theme }) => theme.footer_img_background_color || 'transparent'};
  ${({ theme }) =>
          theme.footer_border_radius &&
          `border-radius: ${pxToRem(theme.footer_border_radius)} ${pxToRem(theme.footer_border_radius)} 0 0`};

  ${({ theme }) => theme.custom_footer_image && theme.custom_footer_image};
`

interface StyledImageFooterProps {
  theme: any;
}
export const StyledImageFooter = styled.img<StyledImageFooterProps>`
  display: flex;
  align-items: center;
  margin: 0 auto ${pxToRem(20)};
  ${({ theme }) => theme.footer_img_top_width && `width: ${pxToRem(theme.footer_img_top_width)}`};
`
interface WidescreenWrapperProps {
  $colorFirst?: string
  $colorSecond?: string
  $backgroundImage?: string
}

export const WidescreenWrapper = styled.div<WidescreenWrapperProps>`
  display: flex;
  width: 100%;
  min-height: 100vh;
`

interface WidescreenLeftPanelProps {
  $colorFirst?: string;
  $colorSecond?: string;
  $backgroundImage?: string;
}
export const WidescreenLeftPanel = styled.div<WidescreenLeftPanelProps>`
  width: 35%;
  height: 100vh;
  position: sticky;
  top: 0;
  background: ${({ $colorFirst, $colorSecond, $backgroundImage }) => {
    if ($backgroundImage && !$colorFirst && !$colorSecond) {
      return `url(${$backgroundImage})`
    }
    if ($colorFirst && $colorSecond) {
      return `linear-gradient(to bottom, ${$colorFirst}, ${$colorSecond})`
    }

    return 'green'
  }};
  background-size: cover;
  background-position: center;
  overflow: hidden;
`

interface WidescreenRightPanelWrapper {
  theme: any
  $borderFormat: string
}

export const WidescreenRightPanelWrapper = styled.div<WidescreenRightPanelWrapper>`
  width: 65%;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.body_background_color ?? '#FFFFFF'};
  border-radius: ${({ $borderFormat }) => {
    if ($borderFormat === 'oris' || $borderFormat === 'orir') {
      return '20px'
    } else {
      return '0px'
    }
  }};
`

interface WidescreenRightPanelProps {
  theme: any
  $borderFormat: string
}

export const WidescreenRightPanel = styled.div<WidescreenRightPanelProps>`
  width: 100%;
  min-height: 100vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  border: 20px solid ${({ theme }) => theme.body_background_color ?? "#FFFFFF"};
  border-radius: ${({ $borderFormat }) => {
    if ($borderFormat === 'oris' || $borderFormat === 'orir') {
      return '20px';
    }
    else { 
      return '0px';
    }
  }};
  box-sizing: border-box;
  box-shadow: -10px 0 10px -5px rgba(0, 0, 0, 0.5);
  z-index: 10;

  p {
    font-size: 18px;
  }
`
